<template>
  <div id="Estadisticas">
    <div class="section">
      <div class="columns">
        <div class="column">
          <div class="card">
            <div class="card-header">
              <div class="card-header-title">Estadísticas</div>
            </div>
            <div class="card-content">
              Estadisticas ultimos días
              <GChart
                type="ColumnChart"
                :data="chartData"
                :options="chartOptions"
              />
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="columns">
        <div class="column">
          <button class="button is-primary" @click="exportar">Exportar</button>
          <button class="button" @click="exportAllData">Exportar todo</button>
          <b-table
            :data="tableData"
            :columns="columns"
            :paginated="isPaginated"
          ></b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { GChart } from "vue-google-charts";
import { ExportToCsv } from "export-to-csv";
var dayjs = require("dayjs");
import db from "../dbdexie";
const DELTADAYS = 3;
export default {
  components: {
    GChart,
  },
  beforeMount: function () {
    this.checkdatabase();
  },

  data() {
    return {
      tableData: [],
      isPaginated: false,
      columns: [
        {
          field: "fecha",
          label: "Fecha",
          width: "40",
          numeric: false,
        },
        {
          field: "Desayuno-Almuerzo",
          label: "Desayuno-Almuerzo",
          width: "80",
          numeric: true,
        },
        {
          field: "Desayuno",
          label: "Desayuno",
          width: "40",
          numeric: true,
        },
        {
          field: "Almuerzo",
          label: "Almuerzo",
          width: "40",
          numeric: true,
        },
        {
          field: "Cena",
          label: "Cena",
          width: "40",
          numeric: true,
        },
        {
          field: "Lavado ropa",
          label: "Lavado ropa",
          width: "40",
          numeric: true,
        },
      ],
      chartData: [
        [
          "fecha",
          "Desayuno-Almuerzo",
          "Desayuno",
          "Almuerzo",
          "Cena",
          "Lavado ropa",
        ],
        [],
      ],
      chartOptions: {
        chart: {
          title: "Registros por día",
          subtitle: "Desayuno-Almuerzo, Desayuno, Almuerzo, Cena, Lavado ropa",
        },
      },
    };
  },
  methods: {
    exportar: async function () {
      const options = {
        fieldSeparator: ";",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: true,
        title: "Export",
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };

      const csvExporter = new ExportToCsv(options);

      csvExporter.generateCsv(this.tableData);
    },
    exportAllData: async function () {
      var result;
      try {
        result = await db.registros
          .where({ fecha: dayjs().format("DD/MM/YYYY") })
          .toArray();
      } catch (error) {
        console.log({ error });
        result = [];
      }
      const options = {
        fieldSeparator: ";",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: true,
        title: "Export",
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };

      const csvExporter = new ExportToCsv(options);

      csvExporter.generateCsv(result);
    },
    checkdatabase: async function () {
      var newchartdata = [
        [
          "fecha",
          "Desayuno-Almuerzo",
          "Desayuno",
          "Almuerzo",
          "Cena",
          "Lavado ropa",
        ],
      ];
      var result;
      //var tableRows = []
      var initdate = dayjs().subtract(DELTADAYS, "day");
      var enddate = dayjs().add(1, "day");
      var servicio = {};
      result = await db.registros
        .where("timestamp")
        .between(initdate.format(), enddate.format())
        .toArray();
      var thisdate;
      for (let k = 0; k <= DELTADAYS; k++) {
        thisdate = initdate.add(k, "day").format("DD/MM/YYYY");
        servicio[thisdate] = {
          fecha: thisdate,
          "Desayuno-Almuerzo": 0,
          Desayuno: 0,
          Almuerzo: 0,
          Cena: 0,
          "Lavado ropa": 0,
        };
      }
      result.forEach(function (item) {
        servicio[item.fecha][item.servicio] += 1;
      });
      for (let dt in servicio) {
        newchartdata.push(Object.values(servicio[dt]));
      }
      this.chartData = newchartdata;
      this.tableData = Object.values(servicio);
    },
  },
};
</script>
